import { z } from 'zod';

/**
 * Provider e modello con cui nasce un nuovo agente AI (chatbot, Personal
 * Assistant): il modello predefinito degli agenti del tenant (`agent_chat`,
 * impostato dalla configurazione consigliata per embedder), già verificato.
 * Risposta di GET /chatbot/agent-llm-default (`data: null` se non disponibile).
 */
export const AgentLlmDefaultSchema = z.object({
  llm_provider: z.enum(['openai', 'claude', 'gemini', 'custom']),
  model: z.string().min(1),
  custom_endpoint_id: z.string().uuid().nullable(),
  custom_model_id: z.string().uuid().nullable(),
});

export type AgentLlmDefault = z.infer<typeof AgentLlmDefaultSchema>;
